
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M12 19C14.2101 19 16.1806 17.9769 17.4651 16.3745L19.0256 17.6255C17.3779 19.681 14.8426 21 12 21C7.805 21 4.28265 18.1308 3.2836 14.2493C3.09829 13.5293 3.00001 12.7754 3.00001 12H0L4 8L8 12H5.00001C5.00001 12.6058 5.07673 13.1922 5.22048 13.7507C5.99761 16.7701 8.73966 19 12 19Z"></path><path d="M16 12L20 16L24 12H20.9999C20.9999 11.2246 20.9017 10.4707 20.7164 9.75074C19.7173 5.86919 16.195 3 11.9999 3C9.15732 3 6.62208 4.31903 4.97433 6.37453L6.53483 7.62547C7.81932 6.02312 9.78981 5 11.9999 5C15.2603 5 18.0023 7.2299 18.7795 10.2493C18.9232 10.8078 18.9999 11.3942 18.9999 12H16Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowloopFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
